<style lang="scss" scoped>
.headers {
  height: 90px;
  line-height: 90px;
  padding: 0 20px;
  font-size: 16px;
}
.nav {
  > a {
    display: inline-block;
    padding-right: 40px;
    cursor: pointer;
  }
  .active {
    color: #2f75ec;
    &::before {
      content: '•';
      margin-right: 10px;
    }
  }
}
.action {
  color: #9b9b9b;
}
</style>

<template>
  <div class="headers">
    <div class="nav fl">
      <router-link to="/">首页</router-link>
      <router-link to="/third/index" class="active">管理中心</router-link>
      <!-- <router-link to="/third">功能介绍</router-link> -->
    </div>
    <div class="action fr">
      <span class="user">{{name}}</span>
      <span class="btn ml40 pointer" @click="logout">退出</span>
    </div>
  </div>
</template>

<script>
import store from 'store';
export default {
  components: {},
  computed: {},
  data() {
    return {
      name: '',
    };
  },
  mounted() {
    this.name = store.get('mobile');
  },
  methods: {
    logout() {
      this.$message({
        message: `成功退出【${this.name}】账号`,
        type: 'success',
        onClose: () => {
          store.remove('password');
          store.remove('token');
          this.$router.push('/login');
        },
      });
    },
  },
};
</script>
